import { TableItem } from '../../../components/Tables'

export const ACTIVITIES_ACCOMMODATIONS_TABLE_CONFIG = (row: any): TableItem[] => {
  return [
    {
      type: 'text',
      label: 'Name',
      value: 'name',
    },
    {
      type: 'text',
      label: 'Address',
      value: 'physical_address',
    },
    {
      type: 'text',
      label: 'Access Instructions',
      value: 'access_instructions',
    },
    {
      type: 'text',
      label: 'Type',
      value: 'type',
    },
    {
      type: 'text',
      label: 'Bedrooms',
      value: 'bedrooms',
    },
    {
      type: 'text',
      label: 'Bathrooms',
      value: 'bathrooms',
    },
    {
      type: 'date',
      label: 'Check In',
      value: 'check_in',
    },
    {
      type: 'date',
      label: 'Check Out',
      value: 'check_out',
    },
    {
      type: 'text',
      label: 'WiFi Info',
      value: 'wifi_info',
    },
    {
      type: 'text',
      label: 'Currency',
      value: 'currency',
    },
    {
      type: 'text',
      label: 'Price Info',
      value: 'price',
    },
  ]
}
